// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"454cbd4e","167":"d518b8e2","169":"f9c1ee2d","246":"415802bf","332":"29747778","989":"ed707d3b"}[chunkId] + ".chunk.css";
};